<template>
  <tr @click="onClickLine" :class="minTable ? '' : 'pointer'">
    <td>
      <div class="d-flex align-center justify-space-between w100">
        <v-icon
            v-if="item['client_reports_exists'] && !minTable"
            :class="dataOpened ? 'rotate' : ''"
        >
          mdi-menu-right-outline
        </v-icon>
        {{ item.project.name }}
        <BaseButton icon_only minimalize class="ml-auto minSize" @click="onOpenProject()">
          <template v-slot:icon>
            <IconsPagesProjects icon="pages-projects" color="#277faf"/>
          </template>
        </BaseButton>
      </div>
    </td>
    <td>{{ item.project.client.name }}</td>
    <td>{{ $formatDate(item['start_date']) + ' - ' + $formatDate(item['end_date']) }}</td>
    <td>{{ item['first_week'] + '-' + item['last_week'] }}</td>
    <td>{{ $formatDate(item['created_at']) }}</td>
    <td>
      <div v-if="userType !== 'subscriber'" class="buttons">
        <div v-if="item.status !== 'new'" class="my-auto">
          <IconTimeControlViewed v-if="item.status !== 'new' && item.status !== 'done'"/>
          <IconTimeControlFullSendCheck v-if="item.status === 'done'"/>
        </div>
        <ButtonShow :open-modal="onOpenReport"/>
        <v-btn
            v-if="minTable && item['client_reports_exists']"
            color="#2F80ED"
            depressed
            text
            @click="onOpenModal"
        >
          <v-icon>mdi-email-mark-as-unread</v-icon>
        </v-btn>
      </div>
    </td>
  </tr>
</template>

<script>
import ButtonShow from '../../ButtonShow.vue'
import BaseButton from '../../base/BaseButton.vue'

import IconTimeControlFullSendCheck from '../../icons/timeControl/IconTimeControlFullSendCheck.vue'
import IconTimeControlViewed from '../../icons/timeControl/IconTimeControlViewed.vue'
import IconsPagesProjects from '../../icons/pages/IconsPagesProjects.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'ProjectReportsTableItem',
  components: {
    IconTimeControlViewed,
    IconTimeControlFullSendCheck,
    IconsPagesProjects,
    BaseButton,
    ButtonShow,
  },
  props: {
    item: [Array, Object],
    clickLine: {},
    openModal: {},
    dataOpened: Boolean,
    minTable: Boolean,
    parentReportId: {},
    setProjectId: {},
  },
  computed: {
    ...mapGetters('user', ['userType']),
  },
  methods: {
    onClickLine() {
      if (this.item.client_reports_exists && this.clickLine && !this.minTable)
        this.clickLine(this.item.id)
    },
    onOpenModal() {
      if (this.item['client_reports_exists'] && this.openModal && this.minTable)
        this.openModal(this.item.id, this.item.project.id)
    },
    onOpenReport() {
      this.$router.push({
        name: 'timeControlShowReportsView',
        params: {id: this.item.project.id, report_id: this.item.id},
      })
    },
    onOpenProject() {
      this.$router.push({
        name: 'ProjectsProjectShow',
        params: {id: this.item.project.id},
      })
    },
  },
}
</script>

<style scoped lang="scss">
.pointer {
  cursor: pointer;
}

:deep() .icon {
  display: flex;
  gap: 14px;
}

.v-btn {
  padding: 0 !important;
  min-width: 10px !important;
  height: 100% !important;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    background: var(--v-primary-base);
    width: 45px !important;
    height: 45px !important;
    border-radius: 50%;
    color: #ffffff !important;

    &:hover {
      opacity: 0.9;
    }
  }
}

.rotate {
  transform: rotate(90deg);
}

.minSize {
  min-width: 34px !important;
  max-width: 35px !important;
}
</style>
